module.exports = __webpack_public_path__ + "static/img/new.d09ba341.svg";